import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import BrochureA5 from "@/pages/BrochureA5";

/** Admin-only wrapper for the A5 brochures. Redirects everyone else to /admin
 *  (or to /login if signed out) so the brochures stay internal. */
export default function AdminOnlyBrochure({ variant }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login?next=/admin" replace />;
  if (user.role !== "admin") return <Navigate to="/admin" replace />;
  return <BrochureA5 variant={variant} />;
}
